import React, { useState } from "react";
import jwt_decode from "jwt-decode";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";

function UploadShareCode() {
    const { instance } = useMsal();
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEmailFormVisible, setIsEmailFormVisible] = useState(false); // State for "Check Email" form visibility
    const [message, setMessage] = useState("");
    const [password, setPassword] = useState("");
    const [dobPassword, setDobPassword] = useState("");
    const [emailPassword, setEmailPassword] = useState(""); // State for "Check Email" password
    const [emailErrors, setEmailErrors] = useState({}); // Errors for "Check Email" form
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const navigate = useNavigate();
    const formType = location.state?.formType || "shareCode";

    let ShareAppUrl = process.env.REACT_APP_SHARE_APP_URL;

    let orgName = localStorage.getItem("orgName");
    let userName = localStorage.getItem("AccessToken")
        ? jwt_decode(localStorage.getItem("AccessToken")).name
        : "Care IO";

    function handleClick(event) {
        event.preventDefault();
        setIsFormVisible(true);
    }

    function handleEmailClick(event) {
        event.preventDefault();
        setIsEmailFormVisible(true); // Show the "Check Email" form
    }

    function handleSubmit(event) {
        event.preventDefault();
        setErrors({});

        let form = event.target;
        let formData = new FormData(form);
        let formDataObj = Object.fromEntries(formData.entries())
        console.log(formDataObj.shareCode)

        window.open(ShareAppUrl + '/upload/app/' + formDataObj.shareCode, '_blank', 'noopener,noreferrer')

        // let formDataObj = { password, dobPassword };
        // let newErrors = {};
        // if (!formDataObj.password) newErrors.password = true;
        // if (!formDataObj.dobPassword) newErrors.dobPassword = true;
        // if (Object.keys(newErrors).length > 0) {
        //     setErrors(newErrors);
        //     return;
        // } else {
        //     setErrors({});
        //     console.log("Form submitted!");
        // }
    }

    function handleEmailSubmit(event) {
        event.preventDefault();
        setEmailErrors({});

        if (!emailPassword) {
            setEmailErrors({ emailPassword: true });
            return;
        } else {
            setEmailErrors({});
            console.log("Email Form submitted!");
        }
    }

    return (
        <div className="col-md-12">
            <div className="col-md-4 offset-4" style={{ padding: "0 80px" }}>
                {formType === "shareCode" && (
                    <form onSubmit={handleSubmit}>
                        <div className="card rounded p-4 linkdiv">
                            <div className="d-flex justify-content-start mb-4">
                                <a className="text-dark" style={{ cursor: "pointer" }} onClick={() => navigate(-1)} >
                                    <i className="fa fa-arrow-left"></i>
                                </a>
                                <h5 className="form-label ms-3">Share Code for Upload</h5>
                            </div>
                            <div className="form-group normal-password">
                                <label className="fw-bold form-label">Share Code</label>
                                <input
                                    id="password"
                                    type="text"
                                    name='shareCode' 
                                    className="form-control form-control-sm"
                                    placeholder="Enter share code"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                {errors.password && (
                                    <span className="text-danger">This field is required</span>
                                )}
                            </div>
                            {/* <div className="form-group dob-password position-relative">
                                <label className="fw-bold form-label"> Birth Date{" "}
                                    <i className="fa fa-question-circle" title="MM/DD/YYYY Format" data-toggle="tooltip" ></i>
                                </label>
                                <DatePicker
                                    selected={dobPassword}
                                    onChange={(date) => setDobPassword(date)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select your birth date"
                                    className="form-control form-control-sm"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                                {errors.dobPassword && (
                                    <span className="text-danger">This field is required</span>
                                )}
                            </div> */}
                            <div className="col-12 mb-2 pl-0">
                                <button className="btn btn-primary btn-sm w-25">Verify</button>
                                <div id="GuestSubmitLoader" className="spinner-border text-muted d-none form-spinner"></div>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default UploadShareCode;
